import React from 'react';
import { CtaButton } from './CtaButton';
const LINKS = [{
  href: '#gap',
  label: 'El gap'
}, {
  href: '#sistema',
  label: 'El sistema'
}, {
  href: '#razones',
  label: 'Por qué funciona'
}, {
  href: '#autoridad',
  label: 'Growth Partner'
}];
export function Nav() {
  return <header className="sticky top-0 z-50 border-b border-white/10 bg-ink-950/85 backdrop-blur" data-id="element-103" data-mp="1b0m5rx0yp65y">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6" data-id="element-104" data-mp="1fzp30vapa83d">
        <a href="#top" className="font-semibold tracking-[0.2em] text-white transition-colors duration-150 ease-out hover:text-accent" data-id="element-105" data-mp="1fxurg7lbjsby">
          GROWTH EULER
        </a>
        <div className="flex items-center gap-8" data-id="element-106" data-mp="1pruw68couvk5">
          <nav aria-label="Secciones" className="hidden items-center gap-8 lg:flex" data-id="element-107" data-mp="1unk00nvqqym9">
            {LINKS.map(link => <a key={link.href} href={link.href} className="text-sm text-zinc-400 transition-colors duration-150 ease-out hover:text-white" data-id="element-108" data-mp="1ys02sga25px9">
                {link.label}
              </a>)}
          </nav>
          <CtaButton label="Auditoría gratis" className="px-5 py-2.5" data-id="element-109" data-mp="1u3k5n5hqmr5z" />
        </div>
      </div>
    </header>;
}